module.exports = __webpack_public_path__ + "static/img/6_2.dd18b13.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/产品及服务/全基因组合成/质粒抽提/6_2.jpg
// module id = DCzb
// module chunks = 1